import { farseerFilesApi } from '../rest/api';
export function downloadFarseerFile(id) {
    return farseerFilesApi.get(id);
}
